<article
  *ngIf="page as event"
  class="event-landing-banner"
  [class]="displayModeClass"
  [class.event-landing-banner--without-media]="!event.imageUrl"
  aria-labelledby="event-landing-banner-title"
>
  <div class="event-landing-banner__card">
    <div class="event-landing-banner__media" *ngIf="event.imageUrl">
      <app-banner-image
        [src]="event.imageUrl"
        [alt]="event.imageAlt || ''"
        [framing]="event.imageFraming"
      ></app-banner-image>
      <button
        *ngIf="showFramingAction"
        type="button"
        class="event-landing-banner__framing-action"
        (click)="adjustFraming.emit()"
      >
        <app-icon name="crop" aria-hidden="true"></app-icon>
        Adjust framing
      </button>
    </div>

    <div class="event-landing-banner__content">
      <div class="event-landing-banner__topline">
        <span
          class="event-landing-banner__badge"
          [class.event-landing-banner__badge--live]="event.status === 'LIVE'"
          [class.event-landing-banner__badge--ended]="event.status === 'ENDED'"
          [class.event-landing-banner__badge--cancelled]="
            event.status === 'CANCELLED'
          "
        >
          {{ statusLabel(event) }}
        </span>
        <button
          type="button"
          class="event-landing-banner__share"
          [disabled]="ctaMode === 'preview'"
          [attr.tabindex]="ctaMode === 'preview' ? -1 : null"
          (click)="emitShare()"
        >
          <app-icon
            name="share-2"
            class="cx-icon--sm"
            aria-hidden="true"
          ></app-icon>
          Share
        </button>
      </div>

      <h2 id="event-landing-banner-title" class="event-landing-banner__title">
        {{ event.heading }}
      </h2>
      <p class="event-landing-banner__featured-name">
        {{ event.featuredName }}
      </p>
      <p class="event-landing-banner__meta" *ngIf="hasSchedule(event)">
        <app-icon
          name="calendar-days"
          class="cx-icon--sm"
          aria-hidden="true"
        ></app-icon>
        {{ formatEventTime(event) }} · {{ event.timezoneLabel }}
      </p>

      <section
        *ngIf="event.status === 'UPCOMING' && countdown"
        class="event-landing-banner__countdown"
        aria-label="Event starts in"
      >
        <p>Event starts in</p>
        <div class="event-landing-banner__countdown-tiles">
          <span class="event-landing-banner__countdown-tile">
            <strong>{{ countdown.days | number : '2.0-0' }}</strong>
            <small>
              <span class="event-landing-banner__countdown-label-long"
                >Days</span
              >
              <span
                class="event-landing-banner__countdown-label-compact"
                aria-hidden="true"
                >Days</span
              >
            </small>
          </span>
          <span class="event-landing-banner__countdown-tile">
            <strong>{{ countdown.hours | number : '2.0-0' }}</strong>
            <small>
              <span class="event-landing-banner__countdown-label-long"
                >Hours</span
              >
              <span
                class="event-landing-banner__countdown-label-compact"
                aria-hidden="true"
                >Hrs</span
              >
            </small>
          </span>
          <span class="event-landing-banner__countdown-tile">
            <strong>{{ countdown.minutes | number : '2.0-0' }}</strong>
            <small>
              <span class="event-landing-banner__countdown-label-long"
                >Minutes</span
              >
              <span
                class="event-landing-banner__countdown-label-compact"
                aria-hidden="true"
                >Min</span
              >
            </small>
          </span>
          <span class="event-landing-banner__countdown-tile">
            <strong>{{ countdown.seconds | number : '2.0-0' }}</strong>
            <small>
              <span class="event-landing-banner__countdown-label-long"
                >Seconds</span
              >
              <span
                class="event-landing-banner__countdown-label-compact"
                aria-hidden="true"
                >Sec</span
              >
            </small>
          </span>
        </div>
      </section>

      <p class="event-landing-banner__description">{{ event.description }}</p>
      <p
        class="event-landing-banner__supporting"
        *ngIf="event.supportingText && !isTerminalStatus(event)"
      >
        {{ event.supportingText }}
      </p>
      <p
        *ngIf="isTerminalStatus(event)"
        class="event-landing-banner__archive-message"
      >
        {{ archiveMessage(event) }}
      </p>

      <div
        *ngIf="!isTerminalStatus(event)"
        class="event-landing-banner__actions"
        [class.event-landing-banner__actions--preview]="ctaMode === 'preview'"
      >
        <p
          *ngIf="showCancel"
          class="event-landing-banner__confirmation"
          role="status"
          aria-live="polite"
        >
          <span class="event-landing-banner__confirmation-mark" aria-hidden="true">✓</span>
          You’re going
        </p>
        <button
          *ngIf="!showCancel"
          type="button"
          class="btn event-landing-banner__action event-landing-banner__action--primary"
          [disabled]="ctaMode === 'preview' || isWorking"
          (click)="emitPrimaryAction()"
        >
          {{ isWorking ? 'Working…' : primaryLabel }}
        </button>
        <button
          *ngIf="showSecondaryAction"
          type="button"
          class="btn event-landing-banner__action event-landing-banner__action--secondary"
          [disabled]="isWorking"
          (click)="secondaryAction.emit()"
        >
          {{ secondaryLabel }}
        </button>
        <button
          *ngIf="showCancel"
          type="button"
          class="btn event-landing-banner__action event-landing-banner__action--tertiary cx-rsvp-cancel-action"
          [disabled]="isWorking"
          (click)="cancelAction.emit()"
        >
          Cancel RSVP
        </button>
        <ng-content select="[eventCalendarAction]"></ng-content>
      </div>
      <p *ngIf="showJoinNotice" class="event-landing-banner__supporting">
        {{ watchNotice }} <a routerLink="/privacy-and-policy">Privacy Policy</a>
      </p>
      <p
        *ngIf="statusMessage"
        class="event-landing-banner__supporting"
        role="status"
        aria-live="polite"
      >
        {{ statusMessage }}
      </p>
    </div>
  </div>
</article>
